import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <>
            <footer>
                <div className="py-6 px-6 text-center">
                    <p className="mb-0 fs-4">Design and Developed by <a href="https://adot.co.in" target="_blank" className="pe-1 text-primary text-decoration-underline">ADOT</a></p>
                </div>
            </footer>
        </>
    )
}

export default Footer;